<div class="popup">
  <!-- Modal content -->
  <div class="modal-content">
    <div class="header">{{header}}</div>
    <div class="body">{{message}}</div>
    <div class="button-container">
      <button type="button" #okButton class="btn btn-primary pull-right" (click)="ok()">{{okButtonName}}</button>
      @if (cancelVisibility) {
        <button type="button" class="btn btn-light pull-right" (click)="cancel()">Cancel</button>
      }
    </div>
  </div>
</div>
